module.exports = __webpack_public_path__ + "img/tg.a2f4dea3.png";